import { defineStore } from "pinia";

export const useCatalogPublicationCollectionsStore = defineStore("CatalogPublicationCollectionsStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchCatalogPublicationCollections(query) {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/v1/catalog/collections?q[original_name_cont]=${query}`);
        this.data = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    },
    async fetchCollection(id) {
      try {
        const response = await this.$axios.get(`/api/v1/catalog/collection/${id}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  }
});
